import { SET_MAP, SET_ZOOM, SET_GEOLOCATION, SET_BOUNDS, SET_PLATFORM } from '../constants/types';

// Data
import mapBounds from '../data/mapBounds.json';

// Helpers
import { setUrl } from '../actions/app';
import { updateUrlZoom, updateUrlBounds, updateUrlPlatform } from '../lib/UrlUtils';
import { retrieveLocations } from './locations';

export const setMap = map => {
  return {
    type: SET_MAP,
    map,
  };
};

export const setZoom = zoom => (dispatch, getState) => {
  dispatch(setUrl(updateUrlZoom(zoom, getState().app.url)));

  dispatch({
    type: SET_ZOOM,
    zoom,
  });
};

export const setPlatform = platForm => (dispatch, getState) => {
  dispatch(setUrl(updateUrlPlatform(platForm, getState().app.url)));

  dispatch({
    type: SET_PLATFORM,
    platForm,
  });
};

export const setGeolocation = geolocation => {
  return {
    type: SET_GEOLOCATION,
    geolocation,
  };
};

export const setBounds = bounds => (dispatch, getState) => {
  dispatch(setUrl(updateUrlBounds(bounds, getState().app.url)));

  dispatch({
    type: SET_BOUNDS,
    bounds,
  });
};

export const updateBounds = bounds => (dispatch, getState) => {
  const { filters } = getState().locations;

  dispatch(setBounds(bounds));
  dispatch(retrieveLocations(bounds, filters));
};

export const initMap = country => dispatch => {
  const { bounds, zoom } = mapBounds[country] ? mapBounds[country] : mapBounds.default;

  if (bounds) dispatch(updateBounds(bounds));
  if (zoom) dispatch(setZoom(zoom));
};
